<template>
    <v-container>
        <v-container fluid>
            <v-row align="start" justify="center">
                <span>
                    <h1>Nosotros</h1>
                </span>
            </v-row>
            <v-row>
                <v-col cols="12" md="4" sm="12" xs="12">
                    <v-card>
                        <v-card-title>
                            <span>
                                Misión
                            </span>
                        </v-card-title>
                        <v-card-text>
                            <p>
                                Solucionar todos tus problemas con las tecnologías de la información asi como guiarte en tus proyectos seleccionando siempre la mejor tecnología
                            </p>
                        </v-card-text>
                    </v-card>
                </v-col>
                <v-col cols="12" md="4" sm="12" xs="12">
                    <v-card>
                        <v-card-title>
                            <span>
                                Visión
                            </span>
                        </v-card-title>
                        <v-card-text>
                            <p>
                                Posicionarnos como la mejor empresa de soluciones informáticas de la zona de Puerto Vallarta y Bahía de Banderas. 
                            </p>
                        </v-card-text>
                    </v-card>
                </v-col>
                <v-col cols="12" md="4" sm="12" xs="12">
                    <v-card>
                        <v-card-title>
                            <span>
                                Nuestro pensamiento
                            </span>
                        </v-card-title>
                        <v-card-text>
                            <p>
                                EL mundo cada dia avanza mas en las Tecnologias de la informacion, por lo cual es nuestro deber mantenerla funcionando, segura y actualizada.
                            </p>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
    </v-container>
</template>

<script>
export default {

}
</script>

<style>

</style>